import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const ERP_API = `${BACKEND_URL}/api/erp`;
export const ERP_TOKEN_KEY = "simserv_erp_token";

export const erpApi = axios.create({ baseURL: ERP_API });

erpApi.interceptors.request.use((config) => {
  const t = localStorage.getItem(ERP_TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "A apărut o eroare. Încearcă din nou.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
